export default __webpack_public_path__ + "static/media/motherchildElephant.bb1d2bb7.jpg";